export const t = { "en": { "crm-index-visualization-core": { "temporaryView": { "defaultName": "Filtered view" } } } };
export const d = [];